module.exports = __webpack_public_path__ + "static/media/promob.e58fba32.png";